module.exports = __webpack_public_path__ + "static/media/Tracking.d17bc09a.svg";